import { StackParamList } from './navigation.types';
import { createZustandStore } from '../utils/zustand';

type InitialRouteStore = {
  initialRoute: { name: keyof StackParamList; params?: Record<string, any> } | undefined;
  initialRouteSet: boolean;
};

export const useInitialRouteStore = createZustandStore(
  'initialRouteStore',
  {
    initialRoute: undefined,
    initialRouteSet: false,
  } as InitialRouteStore,
  (set, get) => ({
    setInitialRoute: (route: InitialRouteStore['initialRoute']) => {
      set({ initialRoute: route, initialRouteSet: true });
    },
  }),
);
